// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
const fetchApi = async (url: string, error: void) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await fetch(url);

    if (!res.ok && res.status !== 404) {
      return error;
    }
    if (res.ok) {
      return await res.json();
    }

    // If the server responds with a 404 error, fetch the root instead
    const rootResponse = await fetch(url);
    return await rootResponse.json();

    // eslint-disable-next-line sonarjs/no-useless-catch
  } catch (error) {
    throw error;
  }
};

export default fetchApi;
